export default "__VITE_ASSET__BpFXBFax__"